module.exports = __webpack_public_path__ + "static/img/wei-yat grand hotel.08d919e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/建置實績/wei-yat grand hotel.png?20181011
// module id = /G66
// module chunks = 1